<template>
  <div>
    <div
      :style="style"
      :class="['backtop', { 'show-icon': showIcon }]"
      @click="handleTop"
    >
      <img
        v-if="config.property_data.icon_url"
        :style="{ width: config.property_data.width + 'px' }"
        :src="config.property_data.icon_url"
      />
      <span v-else>{{ config.property_data.text }}</span>
      <span v-if="isEditorStatus">(请预览效果)</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "tms-back-top",
  props: ["config", "isEditorStatus"],
  computed: {
    style() {
      const positions = {};
      const { left, top, right, bottom } = this.config.property_data;

      switch (this.config.property_data.position) {
        case "lt":
          positions.left = left + "px";
          positions.top = top + "px";
          break;
        case "lb":
          positions.left = left + "px";
          positions.bottom = bottom + "px";
          break;
        case "rt":
          positions.right = right + "px";
          positions.top = top + "px";
          break;
        case "rb":
          positions.right = right + "px";
          positions.bottom = bottom + "px";
          break;
      }
      if (this.isEditorStatus === false) {
        positions.position = "fixed";
      } else {
        positions.opacity = 1;
      }
      return {
        "z-index": 1099,
        ...positions,
      };
    },
  },

  data() {
    return {
      showIcon: false,
      backTopTime: null,
    };
  },
  components: {},
  created() {
    window.addEventListener("scroll", this.watchScrolltop);
  },
  beforeDestroy() {
    clearInterval(this.backTopTime);
    window.removeEventListener("scroll", this.watchScrolltop);
  },
  mounted() {
    console.log(config.property_data.icon_url, "111111111111");
  },
  methods: {
    handleTop() {
      let y = window.scrollY;
      const t = 1000 / 60; // ms 每秒60帧
      let totalT = 500; // ms 用时总长
      if (y < 1000) {
        totalT = 100;
      }
      const offset = y / (totalT / t);
      clearInterval(this.backTopTime);
      this.backTopTime = setInterval(() => {
        y = window.scrollY;
        let curentY = y - offset;
        if (curentY <= 0) {
          curentY = 0;
          clearInterval(this.backTopTime);
        }
        window.scroll(0, y - offset);
        if (window.scrollY <= 0) {
          return;
        }
      }, t);
    },
    watchScrolltop() {
      if (window.scrollY > this.config.property_data.scrollY) {
        this.showIcon = true;
      } else {
        this.showIcon = false;
      }
    },
  },
};
</script>

<style  lang="scss" scoped>
@import "./index.scss";
</style>